<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2>Просмотр загруженного меню</h2>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-card flat tile>
          <v-card-text>
            <v-toolbar flat>
              <v-menu offset-y bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                  class="mx-3"
                  label="Выберите дату"
                  v-model="day"
                  v-on="on"
                  :disabled="inAction"
                  style="max-width: 220px"
                  hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                :disabled="inAction" locale="ru" first-day-of-week="1"
                v-model="day" :landscape="true" :reactive="true"
                ></v-date-picker>
              </v-menu>
              <v-btn
              color="primary"
              class="mx-5"
              :disabled="inAction || !day"
              @click="fetchMenu()"
              >Посмотреть</v-btn>
            </v-toolbar>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <div style="text-align:center">
              <span v-if="items.length === 0">Нет данных</span>
            </div>
            <v-treeview
              dense
              :items="items"
              item-key="id"
            >
              <template v-slot:label="{ item }">
                {{ item.name }}
                <span v-if="item.price"> = <strong>{{ item.price }} руб</strong>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="!deletionDisabled(item)"
                        color="#FF8A80"
                        text
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        @click="deleteProduct(item)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Удалить товар</span>
                  </v-tooltip>
                </span>
                <span v-if="item.isbudget"><strong>{{ item.isbudget }}</strong>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="!deletionDisabled(item)"
                        color="#FF8A80"
                        text
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        :disabled="deletionDisabled(item)"
                        @click="deleteGroup(item)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Удалить группу товаров</span>
                  </v-tooltip>
                </span>
              </template>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <Confirmation></Confirmation>
  </v-container>
</template>

<script>
import Confirmation from '@/components/Confirmation'
import moment from 'moment'
function rubles (kops) {
  return (parseFloat(kops) / 100).toFixed(2)
}

export default {
  name: 'ViewMenu',
  components: { Confirmation },
  data: () => ({
    day: null,
    inAction: false,
    progress: 0,
    menu: null,
    items: [],
    open: []
  }),
  methods: {
    asyncTimeout (to) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, to)
      })
    },
    async fetchMenu () {
      try {
        this.items = []
        const day = this.day
        if (!day) throw new Error('Выберите дату')
        this.progress = 1
        this.inAction = true
        await this.asyncTimeout(500)
        const { menu } = await this.$store.dispatch('sioRequest', {
          topic: 'org-menu',
          pl: { day }
        })
        const cafeids = Object.keys(menu)
        this.items = cafeids.map((x, i) => ({
          id: x,
          name: menu[x].groups.length > 0 ? menu[x].title : `${menu[x].title} (товары не загружены)`,
          children: menu[x].groups.map(g => {
            return {
              ...g,
              id: g.groupid,
              name: g.title,
              isbudget: g.isbudget === true ? ' [Бесплатная группа]' : ' [Платная группа]',
              children: g.products && g.products.length > 0
                ? g.products.map(p => {
                  return {
                    ...p,
                    id: p.productid,
                    name: `${p.title}`,
                    price: rubles(p.price),
                    children: []
                  }
                }) : []
            }
          })
        }))
      } catch (err) {
        console.error(err)
        this.$store.dispatch('snack', err)
      } finally {
        this.inAction = false
      }
    },
    async deleteProduct (product) {
      await this.$store.dispatch('confirm', `Вы действительно хотите удалить товар [${product.name}]?`)
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-product-delete',
          pl: {
            productids: [product.productid],
            day: product.day,
            cafeid: product.cafeid
          }
        })
        this.$store.dispatch('snack', meta.msg)
        await this.fetchMenu()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async deleteGroup (group) {
      await this.$store.dispatch('confirm', `Вы действительно хотите удалить группу товаров [${group.name}]?`)
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-group-delete',
          pl: {
            groupid: group.groupid,
            day: group.day,
            cafeid: group.cafeid
          }
        })
        this.$store.dispatch('snack', meta.msg)
        await this.fetchMenu()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    deletionDisabled (item) {
      return (moment().startOf('day')).isAfter(moment(item.day).startOf('day'))
    }
  },
  watch: {
    day () {
      this.items = []
      this.inAction = false
    }
  },
}
</script>
